

















































































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';
import {defineComponent} from '@vue/composition-api';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';

export default defineComponent({
  name: 'UPEIReactionsPreLab3V2',
  components: {
    FileUploadUiComponent,
    ChemicalNotationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      rxnA: [] as File[],
      rxnB: [] as File[],
      rxnC: [] as File[],
    };
  },
  computed: {
    attachments(): File[] {
      return [...this.rxnA, ...this.rxnB, ...this.rxnC];
    },
  },
});
